import React from "react";
import { Outlet } from "react-router-dom";
import { NavigationBar } from "./NavigationBar";
import { SidePanel } from "../SidePanel/SidePanel";
import { useHasInstance } from "@shared/common/contexts/instanceMetadata/useHasInstance";
import { MessageToastContainer } from "@shared/EDS/components/MessageToast/MessageToastContainer";

export function AppLayout(): React.JSX.Element {
  const instanceIsLoaded = useHasInstance();

  return (
    <div className="flex h-svh flex-col">
      <NavigationBar />
      <div className="flex min-h-0 grow flex-col">
        <tractie-layout
          orientation="horizontal"
          inset="none"
          column-gap="none"
          row-gap="none"
          className="relative h-full min-h-0 w-full flex-auto overflow-hidden"
        >
          {instanceIsLoaded && (
            <tractie-layout-slot slot="start" className="relative">
              <div className="absolute inset-0">
                <SidePanel />
              </div>
            </tractie-layout-slot>
          )}
          <tractie-layout
            inset="none"
            column-gap="none"
            row-gap="none"
            className="relative isolate h-full min-h-0 w-full flex-auto overflow-hidden"
          >
            <div className="absolute inset-0 flex flex-col justify-center overflow-auto">
              <Outlet />
            </div>
          </tractie-layout>
        </tractie-layout>
      </div>
      <MessageToastContainer />
    </div>
  );
}
